import { useLiveQuery } from 'dexie-react-hooks';
import { db } from '@/lib/db';
import type { JobCard } from '@/types/models';

/** The live (not cancelled) job card of a breakdown, from the mirror. */
export function useBreakdownCard(breakdownId: string | undefined): JobCard | undefined {
  return useLiveQuery(async () => {
    if (!breakdownId) return undefined;
    const rows = await db.job_cards.where('breakdown_id').equals(breakdownId).toArray();
    return rows.filter((c) => !c.deleted_at && c.status !== 'cancelled')
      .sort((a, b) => b.opened_at.localeCompare(a.opened_at))[0];
  }, [breakdownId]);
}
